export default __webpack_public_path__ + "5fc4691422bd681fa7684041d2720133.png";